(function () {
  function getEls(root) {
    return {
      month: root.querySelector('select[data-tavern-filter-month]'),
      type: root.querySelector('select[data-tavern-filter-type]'),
      reset: root.querySelector('[data-tavern-filter-reset]'),
      cards: document.querySelectorAll('[data-tavern-drops-card]'),
      rows: document.querySelectorAll('[data-tavern-drops-row]'),
    };
  }

  /** Match plp-facets / facets.js behaviour for .collection-sort-chip (facets.js may not load on this template). */
  function syncGhostChip(select) {
    const chip = select.closest('.collection-sort-chip');
    if (!chip) return;
    const valueEl = chip.querySelector('.collection-sort-chip__value');
    const opt = select.options[select.selectedIndex];
    if (valueEl && opt) valueEl.textContent = opt.text;
  }

  function selectedVendors(root) {
    return Array.from(root.querySelectorAll('.tavern-drops-filter-vendor:checked')).map(function (c) {
      return c.value;
    });
  }

  function syncBrandChip(root) {
    const el = root.querySelector('[data-tavern-brand-chip-value]');
    if (!el) return;
    const emptyLabel = el.getAttribute('data-empty-label') || '';
    const checked = Array.from(root.querySelectorAll('.tavern-drops-filter-vendor:checked'));
    if (checked.length === 0) {
      el.textContent = emptyLabel;
      return;
    }
    if (checked.length === 1) {
      el.textContent = checked[0].value;
      return;
    }
    const names = checked.map(function (c) {
      return c.value;
    });
    el.textContent = names.slice(0, 2).join(', ') + (names.length > 2 ? ' +' + String(names.length - 2) : '');
  }

  function apply(root) {
    const els = getEls(root);
    const month = (els.month && els.month.value) || '';
    const type = (els.type && els.type.value) || '';
    const vendors = selectedVendors(root);
    const vendorFilterActive = root.querySelectorAll('.tavern-drops-filter-vendor').length > 0 && vendors.length > 0;

    els.cards.forEach(function (card) {
      let show = true;
      if (month && card.dataset.releaseMonth !== month) show = false;
      if (type && card.dataset.productType !== type) show = false;
      if (vendorFilterActive && vendors.indexOf(card.dataset.vendor) === -1) show = false;
      card.hidden = !show;
      card.setAttribute('data-hidden', show ? 'false' : 'true');
      var slide = card.closest('.tavern-drops-row__slide');
      if (slide) {
        slide.hidden = !show;
      }
    });

    els.rows.forEach(function (row) {
      const visible = row.querySelectorAll('[data-tavern-drops-card]:not([hidden])').length;
      row.setAttribute('data-row-hidden', visible === 0 ? 'true' : 'false');
    });

    requestAnimationFrame(function () {
      document.querySelectorAll('.tavern-drops-row__track').forEach(function (track) {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        if (track.scrollLeft > max) track.scrollLeft = max;
      });
    });

    syncBrandChip(root);
  }

  function bind(root) {
    if (root.dataset.tavernDropsFiltersBound === 'true') return;
    root.dataset.tavernDropsFiltersBound = 'true';

    const els = getEls(root);
    if (els.month) syncGhostChip(els.month);
    if (els.type) syncGhostChip(els.type);

    root.addEventListener('change', function (event) {
      const t = event.target;
      if (
        !t.matches('select[data-tavern-filter-month], select[data-tavern-filter-type], .tavern-drops-filter-vendor')
      ) {
        return;
      }
      if (t.matches('select[data-tavern-filter-month], select[data-tavern-filter-type]')) {
        syncGhostChip(t);
      }
      apply(root);
    });

    if (els.reset) {
      els.reset.addEventListener('click', function () {
        root.querySelectorAll('.tavern-drops-filter-vendor').forEach(function (cb) {
          cb.checked = false;
        });
        if (els.month) els.month.selectedIndex = 0;
        if (els.type) els.type.selectedIndex = 0;
        if (els.month) syncGhostChip(els.month);
        if (els.type) syncGhostChip(els.type);
        apply(root);
      });
    }

    apply(root);
  }

  function init() {
    document.querySelectorAll('[data-tavern-drops-filters]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
